module.exports = require("@web3auth/torus-wallet-connector-plugin");